import { render, staticRenderFns } from "./TitleTextImage.vue?vue&type=template&id=482e924e&scoped=true&"
import script from "./TitleTextImage.vue?vue&type=script&lang=js&"
export * from "./TitleTextImage.vue?vue&type=script&lang=js&"
import style0 from "./TitleTextImage.vue?vue&type=style&index=0&id=482e924e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482e924e",
  null
  
)

export default component.exports